import React from "react";
import styles from './index.module.scss'
import Snackbar from "@material-ui/core/Snackbar";
import { initializeStore } from "/components/store/store";
import { useState, useEffect } from "react";
import { parseCookies } from "nookies";
import { Alert } from "@material-ui/lab";
import { getWebsiteID } from "/lib/common-functions";
import { useCookies } from "react-cookie";
import FormLoader from "../../../../ui/FormLoader";
import { getReduxSession } from "/lib/sessionHandler";
import { EventCommonObj } from "/lib/services/helpers/eventCommonObject";
import cancel_icon from '~/public/images/grey-cross.svg';
import { useIsMobile } from "/lib/hooks/useIsMobile";

const AddToBagEventDynamic = async (props, cPrice, mPrice, session, variantLabel, sku, qty, website_id, eventCommonObj) => {
    const gaModule = await import('/lib/ga');
    const ga = gaModule as typeof import('/lib/ga');
    ga.AddToBagEvent(props, cPrice, mPrice, session, variantLabel, sku, qty, website_id, eventCommonObj, '');
};

function AddToBag(props) {
    const session = getReduxSession();
    const [showLoader, setShowLoader] = useState(false);
    const isMobileDevice = useIsMobile();
    const cookies = parseCookies(null, "fromClient");
    const [cookie, setCookie] = useCookies(["store"]);
    const [utmsource, setUtmsource] = useCookies(["utm_source"]);
    let website_id = getWebsiteID(cookie);
    const reduxStore = initializeStore();
    const { dispatch } = reduxStore;
    const {
        storeid,
        sku,
        id,
        price,
        mprice,
        type,
        conf,
        variants,
        stock,
        salableqty,
    } = props;

    const ConditionalWrapper = ({ condition, children }) =>
        condition ? children : "";


    const [showMe, setShowMe] = useState(false);
    const [ButtonText, setButtonText] = useState("Add to Bag");
    const [bSnackbarVisible, setTriggerShowSnackbar] = useState(false);

    const [variantLabel, setVariantLabel] = useState(null);
    const [cPrice, setCPrice] = useState(price); // final price
    const [mPrice, setMPrice] = useState(mprice); // regular price
    const [vPrice, setVPrice] = useState(instockVariantPrice(variants));

    const eventCommonObj = EventCommonObj(session, cookie)

    function instockVariantPrice(variants) {
        let variantPrice = 0;
        if (variants && variants.length) {
            for (let i = 0; i < variants.length; i++) {
                if ((variants[i].product.stock_status == 'IN_STOCK')) {
                    variantPrice = variants[i].product.price_range.minimum_price.regular_price.value;
                    break;
                }
            }
        }
        return variantPrice;
    }

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const currency = storeid == 2 ? "$" : "₹";

    const setPrice = async (event) => {
        const selectedsku = event.target.value;
        for (const [index, variant] of variants.entries()) {
            if (variant.product.sku == selectedsku) {
                setCPrice(variant.product.price.regularPrice.amount.value);
                setMPrice(variant.product.price_range.minimum_price.regular_price.value)
                setVPrice(variant.product.price_range.minimum_price.regular_price.value);
                setVariantLabel(variant?.attributes[0]?.label);
                setSelectedIndex(index);
            }
        }
    };
    useEffect(() => {
        setCPrice(price)
        setMPrice(mprice)
        setVPrice(instockVariantPrice(variants));
    }, [id]);
    function isDefaultSelected(index) {
        if (selectedIndex == -1) {
            const value =
                variants[0].product.stock_status == "OUT_OF_STOCK" || (variants[0].product.salableqty.label &&
                    variants[0].product.salableqty.label <= 0)
                    ? variants[index].product.stock_status == "IN_STOCK"
                        ? true
                        : false
                    : index == 0
                        ? true
                        : false;
            return value;
        } else if (index == selectedIndex) {
            return true;
        } else return false;
    }

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        //setOpen(false);
        setTriggerShowSnackbar(false);
    };

    function toggle() {
        setShowMe(!showMe);
    }

    const addtobag = async (event) => {
        event.preventDefault();
        setShowLoader(true)
        setButtonText("Please Wait");
        try {
            const res = await fetch("/api/addtobag", {
                body: JSON.stringify({
                    parentsku:
                        event.target.parentsku && event.target.parentsku.value
                            ? event.target.parentsku.value
                            : "",
                    sku: event.target.sku.value,
                    qty: event.target.qty.value,
                    cookie: cookies,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
            });

            AddToBagEventDynamic(props, cPrice, mPrice, session, variantLabel, event.target.sku.value, event.target.qty.value, website_id, eventCommonObj)

            const bagdata = await res.json();
            if (bagdata?.message) {
                dispatch(
                    {
                        type: 'RESPONSE_MSG',
                        message: bagdata.message,
                        message_type: 'error',
                    })
                setShowLoader(false)
                setButtonText("Add to Bag");
            } else {
                setShowLoader(false)
                setButtonText("Added");
                let cartLink = (website_id == 1) ? "/checkout/cart" : "/international/checkout/cart"
                let cartMsg = `Product added to Bag! <a href="${cartLink}">VIEW BAG</a>`
                dispatch(
                    {
                        type: 'RESPONSE_MSG',
                        message: cartMsg,
                        message_type: 'success',
                    })
                let Qty = (bagdata.total) ? (bagdata.total) : 1
                dispatch(
                    {
                        type: 'INCREMENT',
                        count: Qty,
                    })
                dispatch(
                    {
                        type: 'MINICARTTOTAL',
                        total_price: bagdata.grand_total,
                    })
                setButtonText("Add to Bag");

                const customEvent = new CustomEvent('update', {});
                document.dispatchEvent(customEvent);
                //for times pixel
                if (utmsource['utm_source'] == 'Colombia') {
                    function setAttributes(element, attributes) {
                        Object.keys(attributes).forEach(attr => {
                            element.setAttribute(attr, attributes[attr]);
                        });
                    }
                    const attributes = {
                        id: 'timesimg',
                        height: '1',
                        width: '1',
                        style: 'display:none',
                    };
                    var img = document.createElement("img");
                    setAttributes(img, attributes);
                    img.src = "https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=14381&_w=1&_t=1";
                    var element = document.querySelector('head');
                    element.appendChild(img);
                    img.remove();
                }
            }
        } catch (error) {
            console.log('error addtobag', error);
            setShowLoader(false)
            setButtonText("Add to Bag");
        }
    };
    return (
        <div id={`product_${id}`}>
            <FormLoader show={showLoader} />
            <div className={styles.productitem}>


                {(stock == "OUT_OF_STOCK" || (salableqty.label && salableqty.label <= 0)) && (
                    <button className={styles.outofstock}>Out Of Stock</button>
                )}
                {
                    (stock == "IN_STOCK" && (!salableqty.label || salableqty.label > 0)) && (
                        <div className={styles.btnbag}>
                            <ConditionalWrapper
                                condition={type == "simple" || conf?.[0]?.values.length == 1}
                            >
                                <form onSubmit={addtobag}>
                                    <ConditionalWrapper condition={type == "configurable"}>
                                        <input type="hidden" name="parentsku" value={sku} />
                                        <input
                                            type="hidden"
                                            name="sku"
                                            value={variants && variants[0] ? variants[0].product.sku : sku}
                                        />
                                    </ConditionalWrapper>
                                    <ConditionalWrapper condition={type == "simple"}>
                                        <input type="hidden" name="sku" value={sku} />
                                    </ConditionalWrapper>

                                    <input type="hidden" name="qty" value="1" />

                                    <button type="submit">
                                        {/* <img loading='lazy' src={desk_bag_white} alt="bag icon" height="16" width="16" /> */}
                                        {ButtonText}
                                    </button>
                                </form>
                            </ConditionalWrapper>
                            <ConditionalWrapper
                                condition={type == "configurable" && conf?.[0]?.values.length > 1}
                            >
                                <form onSubmit={addtobag}>
                                    <ConditionalWrapper condition={type == "configurable"}>
                                        <input type="hidden" name="parentsku" value={sku} />
                                    </ConditionalWrapper>

                                    <input type="hidden" name="qty" value="1" />

                                    <button
                                        type="submit"
                                        style={{
                                            display: showMe ? "block" : "none",
                                        }}
                                    >
                                        {/* <img loading='lazy' src={desk_bag_white} alt="bag icon" height="16" width="16" />  */}
                                        {ButtonText}
                                    </button>

                                    <button
                                        onClick={toggle}
                                        style={{
                                            display: showMe ? "none" : "block",
                                        }}
                                    >
                                        {/* <img loading='lazy' src={desk_bag_white} alt="bag icon" width="16" height="19" /> */}
                                        Add to Bag
                                    </button>
                                    <div
                                        style={{
                                            display: showMe ? "block" : "none",
                                        }}
                                        className={styles.view_size_colm}
                                    >
                                        <div className={styles.col}>
                                            <h6>Size</h6>
                                            <a className={styles.close} onClick={toggle}>
                                                <img width={16} height={16} loading='lazy' src={cancel_icon.src} alt="close" />
                                            </a >
                                        </div >
                                        <table>
                                            <tbody>
                                                {conf?.length > 0 &&
                                                    variants.map((value, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="sku"
                                                                        placeholder=""
                                                                        value={variants[index].product.sku}
                                                                        defaultChecked={isDefaultSelected(index)}
                                                                        disabled={
                                                                            variants[index].product.stock_status ==
                                                                                "OUT_OF_STOCK" || (variants[index].product.salableqty.label &&
                                                                                    variants[index].product.salableqty.label <= 0)
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        onClick={setPrice}
                                                                    />
                                                                    {variants[index].attributes[0].label}
                                                                </label>
                                                            </td>
                                                            <td>
                                                                {variants[index].product.stock_status === "OUT_OF_STOCK" ||
                                                                    (variants[index].product.salableqty.label &&
                                                                        variants[index].product.salableqty.label <= 0) ? (
                                                                    <i>Out of Stock</i>
                                                                ) : (
                                                                    <>
                                                                        {variants[index].product.price_range.minimum_price.regular_price.value >
                                                                            variants[index].product.price.regularPrice.amount.value && (
                                                                                <abbr className={styles.cutoffprice}>
                                                                                    <em> {currency} </em>
                                                                                    {variants[index].product.price_range.minimum_price.regular_price.value.toFixed(2)}
                                                                                </abbr>
                                                                            )}

                                                                        <em> {currency} </em>
                                                                        {variants[index].product.price.regularPrice.amount.value.toFixed(2)}
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div >
                                </form >
                            </ConditionalWrapper >
                        </div >
                    )
                }
            </div >
            {bSnackbarVisible && (
                <Snackbar
                    TransitionComponent="down"
                    open={open}
                    autoHideDuration={1500}
                    onClose={handleClose}
                >
                    <Alert onClose={handleClose} severity="success">
                        Product added to Bag!
                    </Alert>
                </Snackbar>
            )}
        </div >
    );
}

export default AddToBag;